import { useEffect } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@contexts/AuthContext';
import { LoadingBlock } from '@components/LoadingBlock';
import { getStoredLocale } from '../i18n/config';

const LAST_SEGMENT_KEY = 'saee:lastPathSegment';

/** `/` → broker app entry with language prefix. */
export function BrokerRootRedirect() {
  const { authLoading, isAuthenticated, profileCompleted } = useAuth();
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (authLoading) return;
    const lng = getStoredLocale();
    if (!isAuthenticated) {
      navigate(`/${lng}/signup`, { replace: true });
      return;
    }
    if (profileCompleted === false) {
      navigate(`/${lng}/signup-complete`, { replace: true });
      return;
    }
    const stored = typeof window !== 'undefined' ? window.localStorage.getItem(LAST_SEGMENT_KEY) : null;
    const segment =
      stored && /^[a-z0-9-]+$/.test(stored) ? stored : 'main-brokerage';
    navigate(`/${lng}/${segment}`, { replace: true });
  }, [authLoading, isAuthenticated, profileCompleted, navigate]);

  useEffect(() => {
    const lng = getStoredLocale();
    if (lng === 'en' || lng === 'ar') {
      void i18n.changeLanguage(lng);
    }
  }, [i18n]);

  if (authLoading) {
    return <LoadingBlock className="min-h-screen" />;
  }
  return <LoadingBlock className="min-h-screen" />;
}

/** `/:lang` only → default dashboard segment. */
export function BrokerLangOnlyRedirect() {
  const { lang } = useParams();
  const safe = lang === 'en' || lang === 'ar' ? lang : getStoredLocale();
  if (lang !== 'en' && lang !== 'ar') {
    return <Navigate to={`/${getStoredLocale()}/main-brokerage`} replace />;
  }
  return <Navigate to={`/${safe}/main-brokerage`} replace />;
}
